module.exports = __webpack_public_path__ + "img/visa.666f05f2.png";